import { atom } from "jotai";

export const solicitudesVacacionesAtom = atom([]);
export const solicitudesVacacionesIdsAtom = atom([]);
export const visibleModalRechazoAtom = atom(false);
export const solicitudVacacionesSeleccionadaAtom = atom([]);
export const envioRechazoAtom = atom("");